// extracted by mini-css-extract-plugin
export var banner = "_35-0";
export var icon = "_35-1";
export var message = "_35-2";